import React, { useEffect, useState } from "react";
import "./style.scss";
import CloseBtn from "../CloseBtn";
import UserCard from "../UserCard";
import Address from "../Address";
import TitleExpand from "../Expandtitle";
import Gridimages from "../Imagesgrid";
import Location from "../Location";
import Datedetails from "../Datedetails";
import SuperstarItem from "../SuperstarItem";
import Storelist from "../../Store/Actions";
import { DateSeparter } from "../../Utils/helper";
import Api from "../../Utils/Api";
import ServiceTracking from "../ServiceTracking";
import moment from "moment";
import AssignTechnicianModal from "../AssignTechnicianModal/AssignTechnicianModal";
import AmcVerificationModal from "../AmcVerificationModal/AmcVerificationModal";
import { DateTime } from "luxon";
import PickupModal from "../PickupModal/PickupModal";
import DropModal from "../DropModal/DropModal";
import { toast } from "react-toastify";

const RequestDetails = () => {
  const {
    ServiceDetailsStore,
    setServiceDetailsData_,
    setServiceTrackingData_,
    AssignTechnician,
    setReschedule,
    pickUpModal,
    dropModal,
    RequestUserStore
  } = Storelist();

  const handleReschedule = () => {
    setReschedule(true);
    AssignTechnician(false);
  };

  const { verifyOTP, GetAvailableTechnician,GetOfferAndServiceRequiredList } = Api();

  const serviceDetail = ServiceDetailsStore?.data;

  const closeHandler = () => {
    setServiceDetailsData_(null);
    setServiceTrackingData_(null);
    setReschedule(false);
  };

  const [value, setValue] = useState("");
  const [amcModalOpen, setAmcModalOpen] = useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    // Allow only numbers and max 4 digits
    if (/^\d{0,4}$/.test(newValue)) {
      setValue(newValue);
    }
  };

  const submitVerifyOtp = (e) => {
    e.preventDefault();
    if(value.length < 4) {
      toast.warn("please enter valid otp") 
      return
    }
    console.log("rftyuiop")
    const otp = value;
    // Call API to verify OTP
    verifyOTP({ serviceId: serviceDetail?.bikeRequest._id, sotp: otp });
    setValue("");
  };

  useEffect(() => {
    console.log(
      "serviceDetail?.bikeRequest",
      serviceDetail?.bikeRequest?.slotBooked
    );
    setValue("");
  }, [serviceDetail?.bikeRequest]);


  const openModal = () => {
    const data = {};
    data.branchId = serviceDetail?.bikeRequest?.branch;
    data.serviceType = serviceDetail?.bikeRequest?.serviceType?._id;

    GetAvailableTechnician(data);
    AssignTechnician(true);
    setReschedule(false);
  };

  const renderButton = () => {
    if (
      serviceDetail?.bikeRequest?.serviceStatus === "NEW" ||
      serviceDetail?.bikeRequest?.serviceStatus === "ACCEPTED" ||
      serviceDetail?.bikeRequest?.serviceStatus === "COMPLETED"
    ) {
      if (serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode === "IDIS") {
        if (serviceDetail?.bikeRequest?.isStoreVerified === 1) {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  };

  const dateFormatter = (date) => {
    return moment(date).format("DD-MM-YYYY");
  };
  return (
    <div className="request-detail-container">
      <CloseBtn color={"--dark"} closeHandler={closeHandler} />
      <UserCard
        title={serviceDetail?.bikeRequest?.customerName || ""}
        titleDescription={
          serviceDetail?.bikeRequest?.memberSince
            ? `Member since ${serviceDetail?.bikeRequest?.memberSince}`
            : ""
        }
        day={DateSeparter(serviceDetail?.bikeRequest?.slotBooked)?.day}
        date={DateSeparter(serviceDetail?.bikeRequest?.slotBooked)?.date}
        color={"--dark"}
      />

      <Address
        color={"--dark"}
        addressType={serviceDetail?.bikeRequest?.addressId?.addressType}
        full_address={serviceDetail?.bikeRequest?.addressId?.fullAddress}
        city={serviceDetail?.bikeRequest?.addressId?.city}
        state={serviceDetail?.bikeRequest?.addressId?.state}
        pincode={serviceDetail?.bikeRequest?.addressId?.pincode}
        mobileNumber={serviceDetail?.bikeRequest?.mobileNumber}
      />

      <div className="request-bike-name">
        <TitleExpand title={"Bicycle Details"} color={"--dark"} />
      </div>
      <div className="request-specification-container">
        <div className="list-item">
          <p className="title">Brand</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.bike?.brand?.brandName || "-"}
          </p>
        </div>
        <div className="list-item">
          <p className="title">Model</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.bike?.model || "------"}
          </p>
        </div>

        <div className="list-item">
          <p className="title">Bicycle Type</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.bike?.bikeType?.configValue || ""}
          </p>
        </div>
        <div className="list-item">
          <p className="title">Frame number</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.frameNumber || "------"}
          </p>
        </div>
        <div className="list-item">
          <p className="title">Gear Type</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.bike?.gearSystem?.configValue ||
              "------"}
          </p>
        </div>
      </div>

      <div className="request-bike-name">
        <TitleExpand title={"service Details"} color={"--dark"} />
      </div>
      <div className="request-specification-container">
        <div className="list-item">
          <p className="title">Service Type</p>
          <p className="value" style={{ marginLeft: "10px", fontSize: "14px" }}>
            {serviceDetail?.bikeRequest?.serviceType?.serviceTypeDescription ||
              "-"}
          </p>
        </div>
        <div className="list-item ">
          <p className="title">Service Package</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.packageType?.serviceCategoryName ||
              "------"}
          </p>
        </div>
        <div className="list-item ">
          <p className="title">Slot Date</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.slotBooked?.split("T")[0] || "------"}
          </p>
        </div>
        <div className="list-item ">
          <p className="title">Slot Time</p>
          <p className="value">
            {DateTime.fromISO(serviceDetail?.bikeRequest?.slotBooked, {
              zone: "utc",
            })
              .setZone("Asia/Kolkata")
              .toFormat("h:mm a") || "------"}
          </p>
        </div>
        <div className="list-item ">
          <p className="title">Amount</p>
          <p className="value">
            {serviceDetail?.bikeRequest?.price || "------"}
          </p>
        </div>
      </div>
            
      {serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode === "PUMB" &&
        serviceDetail?.bikeRequest?.serviceStatus === "ACCEPTED" &&
        serviceDetail?.bikeRequest?.pickupStatus !== "ARRIVED" && (
          
          <>
            <div className="request-bike-name">
              <TitleExpand title={"Do Pickup"} color={"--dark"} />
            </div>
            <div className="request-specification-container">
              <a
                href="#"
                onClick={() => {
                  pickUpModal();
                }}
              >
                {" "}
                Open Pickup Panel
              </a>
            </div>
          </>
        )}

      {serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode === "PUMB" &&
        serviceDetail?.bikeRequest?.serviceStatus === "COMPLETED" &&
        serviceDetail?.bikeRequest?.dropStatus !== "DELIVERED" && (
          
          <>
            <div className="request-bike-name">
              <TitleExpand title={"Do Drop"} color={"--dark"} />
            </div>
            <div className="request-specification-container">
              <a
                href="#"
                onClick={() => {
                  dropModal();
                }}
              >
                {" "}
                Open drop Panel
              </a>
            </div>
          </>
        )}

      {serviceDetail?.bikeRequest?.amcId &&
        Object.keys(serviceDetail?.bikeRequest?.amcId).length > 0 && (
          <>
            <div className="request-bike-name">
              <TitleExpand title={"AMC details"} color={"--dark"} />
            </div>
            <div className="request-specification-container">
              <div className="list-item">
                <p className="title"> Remaining service</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {parseInt(serviceDetail?.bikeRequest?.amcId?.totalService) -
                    parseInt(serviceDetail?.bikeRequest?.amcId?.serviceCount)}
                </p>
              </div>
              <div className="list-item ">
                <p className="title">AMC Status</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {serviceDetail?.bikeRequest?.amcId?.status}
                </p>
              </div>
              <div className="list-item">
                <p className="title">AMC Activation Date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.amcId?.amcStartDate
                  )}
                </p>
              </div>
              <div className="list-item">
                <p className="title">AMC Expiration date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.amcId?.amcExpiryDate
                  )}
                </p>
              </div>
              <div className="list-item">
                <p className="title">Purchase Date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.amcId?.purchaseDate
                  )}
                </p>
              </div>
              <div className="list-item ">
                <p className="title">AMC Verification</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  <button
                    type="button"
                    onClick={() => setAmcModalOpen(true)}
                    className="underline cursor-pointer bg-transparent border-0 p-0"
                    style={{
                      color: "#f05a28",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    Click here
                  </button>
                </p>
              </div>
            </div>
          </>
        )}
      {serviceDetail?.bikeRequest?.warrantyId &&
        Object.keys(serviceDetail?.bikeRequest?.warrantyId).length > 0 && (
          <>
            <div className="request-bike-name">
              <TitleExpand title={"Warranty details"} color={"--dark"} />
            </div>
            <div className="request-specification-container">
              <div className="list-item">
                <p className="title"> Remaining service</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {parseInt(serviceDetail?.bikeRequest?.warrantyId?.totalService) -
                    parseInt(serviceDetail?.bikeRequest?.warrantyId?.serviceCount)}
                </p>
              </div>
              <div className="list-item ">
                <p className="title">Warranty Status</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {serviceDetail?.bikeRequest?.warrantyId?.status}
                </p>
              </div>
              <div className="list-item">
                <p className="title">Activation Date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.warrantyId?.warrantyStartDate
                  )}
                </p>
              </div>
              <div className="list-item">
                <p className="title">Expiration date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.warrantyId?.warrantyExpiryDate
                  )}
                </p>
              </div>
              <div className="list-item">
                <p className="title">Purchase Date</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  {dateFormatter(
                    serviceDetail?.bikeRequest?.warrantyId?.purchaseDate
                  )}
                </p>
              </div>
              <div className="text-sm mt-5">
                free service will expire on <b>
                {dateFormatter(
                    serviceDetail?.bikeRequest?.warrantyId?.serviceExpiryDate
                  )}</b></div>
              {/* <div className="list-item ">
                <p className="title">AMC Verification</p>
                <p
                  className="value"
                  style={{ marginLeft: "10px", fontSize: "14px" }}
                >
                  <a
                    href={`${amc_redirect_url}#/certificate?amcId=${serviceDetail?.bikeRequest?.amcId?._id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    Click here
                  </a>
                </p>
              </div> */}
            </div>
          </>
        )}

      {serviceDetail?.bikeRequest?.serviceTechnician && (
        <div>
          <div className="request-bike-name">
            <TitleExpand title={"Technician Details"} color={"--dark"} />
          </div>
          <div className="request-specification-container">
            <div
              className={`${
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.availability &&
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.id ===
                  serviceDetail?.bikeRequest?.serviceTechnician?._id &&
                "absent-warning"
              } list-item`}
            >
              <p className="title"> Technician Name</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.serviceTechnician?.name}
              </p>
            </div>
            <div className={`list-item`}>
              <p className="title">Mobile Number</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.serviceTechnician?.mobileNumber}
              </p>
            </div>
            <div className="list-item">
              <p className="title">Employee Id</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.serviceTechnician?.employeeId}
              </p>
            </div>
          </div>
        </div>
      )}

      {serviceDetail?.bikeRequest?.pickUpPerson && (
        <div>
          <div className="request-bike-name">
            <TitleExpand title={"pickup person details"} color={"--dark"} />
          </div>
          <div className="request-specification-container">
            <div
              className={`list-item ${
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.availability &&
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.id ===
                  serviceDetail?.bikeRequest?.pickUpPerson?._id &&
                "absent-warning"
              }`}
            >
              <p className="title"> Technician Name</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.pickUpPerson?.name}
              </p>
            </div>
            <div className={`list-item`}>
              <p className="title">Mobile Number</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.pickUpPerson?.mobileNumber}
              </p>
            </div>
            <div className="list-item">
              <p className="title">Employee Id</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.pickUpPerson?.employeeId}
              </p>
            </div>
          </div>
        </div>
      )}

      {serviceDetail?.bikeRequest?.dropPerson && (
        <div>
          <div className="request-bike-name">
            <TitleExpand title={"Drop person details"} color={"--dark"} />
          </div>
          <div className="request-specification-container">
            <div
              className={`list-item ${
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.availability &&
                serviceDetail?.bikeRequest?.isTechnicianAbsent?.id ===
                  serviceDetail?.bikeRequest?.dropPerson?._id &&
                "absent-warning"
              }`}
            >
              <p className="title"> Technician Name</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.dropPerson?.name}
              </p>
            </div>
            <div className="list-item">
              <p className="title">Mobile Number</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.dropPerson?.mobileNumber}
              </p>
            </div>
            <div className="list-item">
              <p className="title">Employee Id</p>
              <p
                className="value"
                style={{ marginLeft: "10px", fontSize: "14px" }}
              >
                {serviceDetail?.bikeRequest?.dropPerson?.employeeId}
              </p>
            </div>
          </div>
        </div>
      )}

      {serviceDetail?.bikeRequest?.bike?.bikeImagesFullUrl?.length > 0 && (
        <div className="request-images-container">
          <TitleExpand title={"BICYCLE IMAGES"} color={"--dark"} />

          <div className="bike-images">
            <Gridimages>
              {serviceDetail?.bikeRequest?.bike?.bikeImagesFullUrl?.map(
                (el, index) => {
                  return (
                    <a href={el}>
                      <img alt={`img ${index}`} src={el} />
                    </a>
                  );
                }
              )}
            </Gridimages>
          </div>
        </div>
      )}

      {serviceDetail?.bikeRequest?.additionalComments && (
        <div className="request-notes-container">
          <TitleExpand title={"NOTES FROM CUSTOMER"} color={"--dark"} />

          <p className="notes">
            {serviceDetail?.bikeRequest?.additionalComments}
          </p>
        </div>
      )}

      {serviceDetail?.bikeRequest?.isStoreVerified === 1 && (
        <div className="request-notes-container">
          <TitleExpand title={"Verify otp"} color={"--dark"} />
          <p className="notes flex justify-evenly">
            <input
              type="number"
              maxLength={4}
              value={value}
              onChange={handleChange}
              placeholder="enter service otp"
              className="store-manager-verify-otp border border-rounded p-[100px]"
            />
            <button className="border verify-otp-btn" onClick={submitVerifyOtp}>
              Verify
            </button>
          </p>
        </div>
      )}

      <div className="request-timeline-container">
        <TitleExpand title={"TIMELINE"} color={"--dark"} />

        <ServiceTracking></ServiceTracking>
      </div>

      <div className="request-timeline-container">
        {renderButton() && (
          <div className="modify-btn-container">
            {serviceDetail?.bikeRequest?.serviceStatus === "NEW" && (
              <button className="service-modify-btn" onClick={openModal}>
                Assign Technician
              </button>
            )}

            {serviceDetail?.bikeRequest?.serviceStatus === "ACCEPTED" && (
              <button className="service-modify-btn" onClick={openModal}>
                Reassign Technician
              </button>
            )}

            {serviceDetail?.bikeRequest?.serviceStatus === "COMPLETED" &&
              serviceDetail?.bikeRequest?.serviceType?.serviceTypeCode ===
                "PUMB" && (
                <button className="service-modify-btn" onClick={openModal}>
                  {" "}
                  Reassign DropPerson
                </button>
              )}

            {(serviceDetail?.bikeRequest?.serviceStatus === "NEW" ||
              serviceDetail?.bikeRequest?.serviceStatus === "ACCEPTED") && (
              <button className="service-modify-btn" onClick={handleReschedule}>
                {" "}
                Reschedule
              </button>
            )}
          </div>
        )}
      </div>
      <AssignTechnicianModal></AssignTechnicianModal>
      <AmcVerificationModal
        open={amcModalOpen}
        amcId={serviceDetail?.bikeRequest?.amcId?._id}
        onClose={() => setAmcModalOpen(false)}
      />
      <PickupModal></PickupModal>
      <DropModal></DropModal>
    </div>
  );
};

export default RequestDetails;
